import app from './app';
import appointment from './appointment';
import availability from './availability';
import booking from './booking';
import calendar from './calendar';
import consultationView from './consultationView';
import expert from './expert';
import loader from './loader';
import locationMiddleware from './locationMiddleware';
import patient from './patient';
import serialization from './serialization';
import slot from './slot';
import upload from './upload';
import videoconference from './videoconference';
import workflow from './workflow';
import { CONSULTATION_CREATION } from 'FRONTEND/actions/constants';
import { consultationCodesApi } from 'FRONTEND/utils/backendApi/consultationCodesApi';
import { consultationsApi } from 'FRONTEND/utils/backendApi/Consultations/consultationsApi';
import { drugReferencesApi } from 'FRONTEND/utils/backendApi/drugReferencesApi';

export const createMiddlewares = () => (getDefaultMiddleware) => {
  return [
    ...getDefaultMiddleware({
      serializableCheck: {
        // This action passes a FormData as parameter (non-serializable) that isn't stored into reducer, so it is ok to ignore the check.
        ignoredActions: [CONSULTATION_CREATION],
      },
    }),
    consultationsApi.middleware, // RTK Query middlewares MUST come first
    consultationCodesApi.middleware,
    drugReferencesApi.middleware,
    app,
    availability,
    appointment,
    booking,
    slot,
    calendar,
    consultationView,
    expert,
    loader,
    patient,
    upload,
    videoconference,
    workflow,
    locationMiddleware,
    serialization, // Order may be important, should remain last
  ];
};
